module.exports = __webpack_public_path__ + "src/assets/sounds/dish_opening_sound.mp3";